import throttle from "./throttle";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

var ScrollTween;
{
    gsap.registerPlugin(ScrollTrigger);

    ScrollTween = class {
        constructor(_options) {
            const defaults = {
                element: null,
                from: "top-bottom",
                to: "bottom-top",
                callback: function (_n, _el) {},
                css: false,
                threshold: 1,
                decimalPlaces: 3,
                debug: false,
            };
            const options = Object.assign({}, defaults, _options);

            this.element = options.element;
            this.from = options.from;
            this.to = options.to;
            this.callback = options.callback;
            this.css = options.css;
            this.threshold = options.threshold;
            this.decimalPlaces = options.decimalPlaces;
            this.debug = options.debug;

            this.trigger;
            this.roundingNumber = Math.pow(10, this.decimalPlaces);

            this.init();
        }

        init() {
            var callback = this.callback;
            var element = this.element;
            this.trigger = ScrollTrigger.create({
                trigger: this.element,
                start: typeof this.from == "string" ? this.from.replace("-", " ") : this.from,
                end: typeof this.to == "string" ? this.to.replace("-", " ") : this.to,
                onUpdate: function (self) {
                    callback(self.progress, element);
                },
                markers: this.debug,
                scrub: true,
            });

            if (this.css) this.element.style.setProperty("--i", " " + this.getProgress());
            this.callback(this.getProgress(), this.element);

            if (this.debug) {
                console.log(this);
            }

            return this;
        }

        getProgress() {
            return Math.round(this.trigger.progress * this.roundingNumber) / this.roundingNumber;
        }
    };

    window.addEventListener("resize", ScrollTrigger.refresh);

    document.addEventListener("DOMContentLoaded", function () {
        new ResizeObserver(
            throttle(function () {
                ScrollTrigger.refresh();
            }, 100)
        ).observe(document.body);
    });
}

export default ScrollTween;
